module.exports = __webpack_public_path__ + "static/media/logooba.6431469d.png";